import * as React from 'react';
import { Integration, IntegrationError, IntegrationRefreshStatus, IntegrationErrorType } from '../types';
import { antGrey, runwayColors } from '../components/styles/globalStyles';
import { WarningOutlined, ExclamationCircleOutlined, CheckOutlined } from '@ant-design/icons';
import Text from 'antd/lib/typography/Text';
import SmallStatusNode from '../components/SmallStatusNode';
import { compact } from 'lodash';

export const combinedStatusForIntegrationRefreshData = (integrations: Integration[]) => {
    if (integrations.length === 0) {
        return IntegrationRefreshStatus.Warning;
    }

    const integrationErrors = compact(
        integrations.map((integration) => {
            return integration.integrationError;
        }),
    );

    if (integrationErrors.length === 0) {
        return IntegrationRefreshStatus.Success;
    }

    let combinedRefreshStatus = IntegrationRefreshStatus.Success;
    for (const integrationError of integrationErrors) {
        const refreshStatus = statusForIntegrationRefreshData(integrationError);
        if (refreshStatus === IntegrationRefreshStatus.Warning) {
            combinedRefreshStatus = refreshStatus;
        } else if (refreshStatus === IntegrationRefreshStatus.Error) {
            combinedRefreshStatus = refreshStatus;
            break;
        }
    }

    return combinedRefreshStatus;
};

export const statusForIntegrationRefreshData = (integrationError?: IntegrationError) => {
    if (integrationError == null) {
        return IntegrationRefreshStatus.Success;
    }
    switch (integrationError.status) {
        case IntegrationErrorType.IncompleteData:
        case IntegrationErrorType.IncorrectData:
            return IntegrationRefreshStatus.Warning;

        default:
            return IntegrationRefreshStatus.Error;
    }
};

export const statusNodeForIntegrationStatus = (status: IntegrationRefreshStatus) => {
    switch (status) {
        case IntegrationRefreshStatus.Success:
            return <SmallStatusNode color={runwayColors.statusGreen} size={8} />;
        case IntegrationRefreshStatus.Warning:
            return <SmallStatusNode color={runwayColors.statusYellow} size={8} />;
        case IntegrationRefreshStatus.Error:
            return <SmallStatusNode color={runwayColors.statusRed} size={8} />;
    }
};

export const iconForIntegrationStatus = (refreshStatus: IntegrationRefreshStatus) => {
    switch (refreshStatus) {
        case IntegrationRefreshStatus.Success:
            return <CheckOutlined style={{ color: antGrey.grey6, fontSize: 12 }} />;
        case IntegrationRefreshStatus.Warning:
            return <ExclamationCircleOutlined style={{ color: antGrey.grey6, fontSize: 12 }} />;
        case IntegrationRefreshStatus.Error:
            return <WarningOutlined style={{ color: antGrey.grey6, fontSize: 12 }} />;
    }
};

export const buildIntegrationTooltipContent = (header?: string | null, body?: string | null, headerColor?: string) => {
    if (!header && !body) return '';
    return (
        <div>
            {header && (
                <Text strong style={{ color: headerColor, display: 'block', fontSize: 12 }}>
                    {header}
                </Text>
            )}
            {body && <Text style={{ color: antGrey.grey1, fontSize: 12 }}>{body}</Text>}
        </div>
    );
};
